import { IAppointmentListing, ISuperAppointmentListing } from '.';

export interface IGeneralAppointments {
    ListAppointmentListItems?: IAppointmentListing[];
    ListSupperAppointments?: ISuperAppointmentListing[];
}
export class GeneralAppointments implements IGeneralAppointments {
    ListAppointmentListItems?: IAppointmentListing[];
    ListSupperAppointments?: ISuperAppointmentListing[];

    constructor(data?:any) {
        this.ListAppointmentListItems = data.ListAppointmentListItems ? data.ListAppointmentListItems : (data.listOfItems ? data.listOfItems : []);
        this.ListSupperAppointments = data.ListSupperAppointments || [];
    }
}